import { isKeyOfRecord } from './helpers.js';
import { isRecordManagerWithWorkflows } from '../../storeUtilities/recordManager/helper.js';

const getRecordManagerByStoreRef = (storeRef, managers) => {
    if (!isKeyOfRecord(storeRef, managers)) {
        console.error('[WF]: Invalid record manager index', storeRef);
        return;
    }
    const rm = managers[storeRef];
    if (!rm || !isRecordManagerWithWorkflows(rm)) {
        console.error('[WF]: Invalid record manager', storeRef);
        return;
    }
    return rm;
};
const getRecordManagerByWorkflowItem = (workflowItem, managers) => {
    const rmIndex = workflowItem.recordMeta.storeRef;
    if (!isKeyOfRecord(rmIndex, managers)) {
        console.error('[WF]: Invalid record manager index', rmIndex);
        return;
    }
    const rm = managers[rmIndex];
    if (!rm || !isRecordManagerWithWorkflows(rm)) {
        console.error('[WF]: Invalid record manager', rmIndex);
        return;
    }
    return rm;
};
const getItemWorkflowByContext = (workflowItem, rm) => {
    var _a, _b;
    const { referenceID } = workflowItem.recordMeta;
    const item = rm.getRawClone(referenceID);
    if (!item) {
        console.error('[WF]: Record not found', referenceID);
        return;
    }
    const workflows = rm.getters.workflows(item);
    if (!workflows) {
        console.error('[WF]: Record has no workflows', workflowItem.recordMeta.referenceID);
        return;
    }
    const { context, referenceID: parentReferenceID, } = (_a = workflowItem.recordMeta.parent) !== null && _a !== void 0 ? _a : {};
    const workflow = (_b = workflows === null || workflows === void 0 ? void 0 : workflows[parentReferenceID]) === null || _b === void 0 ? void 0 : _b[context];
    if (!workflow) {
        console.error('[WF]: Record has no workflow of this context', context);
        return;
    }
    return workflow;
};

export { getItemWorkflowByContext, getRecordManagerByStoreRef, getRecordManagerByWorkflowItem };
